import { Link, router } from "@inertiajs/react"
import { BackofficeLayout } from "@/components/layout/BackofficeLayout"
import { SearchInput } from "@/components/shared/SearchInput"
import { Pagination, PaginationMeta } from "@/components/shared/Pagination"
import { Badge } from "@/components/ui/badge"
import { StageBadge } from '@/components/shared/StageBadge'
import type { BackofficeNomineeShareholder } from "@/types"

type Props = {
  nominee_shareholders: BackofficeNomineeShareholder[]
  search: string
  pagination: PaginationMeta
}

export default function BackofficeNomineeShareholdersIndex({ nominee_shareholders, search, pagination }: Props) {
  return (
    <BackofficeLayout title="Nominee Shareholder Services" breadcrumbs={[{ label: "Backoffice", href: "/backoffice/dashboard" }, { label: "Nominee Shareholders" }]}>
      <div className="mb-8">
        <h1 className="text-xl font-semibold tracking-tight">Nominee Shareholder Services</h1>
        <p className="text-sm text-muted-foreground">{pagination.total} {pagination.total === 1 ? "service" : "services"}</p>
      </div>

      <SearchInput value={search} placeholder="Search services..." />

      <div className="mt-4">
        {nominee_shareholders.length === 0 ? (
          <div className="border rounded-lg py-16 text-center">
            <h3 className="text-sm font-medium text-foreground mb-1">No services yet</h3>
          </div>
        ) : (
          <div className="border rounded-lg">
            {nominee_shareholders.map((ns, i) => (
              <div
                key={ns.id}
                className={`px-4 py-3 cursor-pointer hover:bg-muted/50 transition-colors ${i > 0 ? "border-t" : ""}`}
                onClick={() => router.visit(`/backoffice/nominee_shareholders/${ns.id}`)}
              >
                <div className="flex items-center justify-between">
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <Link href={`/backoffice/nominee_shareholders/${ns.id}`} className="text-sm font-medium hover:underline">{ns.business_name}</Link>
                      <span className="text-[12px] text-muted-foreground">{ns.type_name}</span>
                    </div>
                    <div className="text-xs text-muted-foreground mt-0.5">
                      {ns.account_name} · {ns.jurisdiction_label || "—"} · {ns.duration_months} months
                    </div>
                  </div>
                  <div className="ml-4">
                    <StageBadge stage={ns.stage} variant="service" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mt-4">
        <Pagination pagination={pagination} />
      </div>
    </BackofficeLayout>
  )
}
